// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'archive-solid';

export const Component = () => (
  <g fill='currentColor' stroke='currentColor' strokeLinecap='round'>
    <path
      strokeLinejoin='round'
      d='M15.906 1.74H2.094A1.063 1.063 0 0 0 1.03 2.802v2.125h15.94V2.802a1.063 1.063 0 0 0-1.063-1.062z'
    />
    <path d='M16 14.05a2.2 2.2 0 0 1-2.2 2.2H4.2a2.2 2.2 0 0 1-2.2-2.2V7h14zM7.583 7.26c-.353 0-.651.09-.892.25a1.44 1.44 0 0 0-.485.558 1.81 1.81 0 0 0-.183.674c-.018.262-.002.527-.002.79l.003.13c.02.296.106.55.247.76.158.238.365.39.557.486a1.809 1.809 0 0 0 .674.183c.961.068 1.95.003 2.914.003.353 0 .651-.09.892-.25.237-.158.389-.366.485-.558a1.806 1.806 0 0 0 .186-.725v-.738c0-.353-.09-.651-.25-.891a1.433 1.433 0 0 0-.558-.486 1.806 1.806 0 0 0-.673-.182c-.02-.002-.04-.002-.053-.002l-.017-.001z' />
  </g>
);

export const viewBox = '0 0 18 18';
